export default [{
  path: '/gjyxb',
  component: () => import('./views/index.vue')
}, {
  path: '/gjyxb/introduce',
  component: () => import('./views/introduce.vue')
}, {
  path: '/gjyxb/picc',
  component: () => import('./views/picc.vue')
},
  {path: '/gjyxb/hos', component: () => import('./views/hos.vue')},
  {
    path: '/gjyxb/pre',
    component: () => import('./views/pre')
  }, {
    path: '/gjyxb/form/1',
    component: () => import('./views/form1.vue')
  }, {
    path: '/gjyxb/form/2',
    component: () => import('./views/form2.vue')
  }, {
    path: '/gjyxb/form/3',
    component: () => import('./views/form3.vue')
  }]



// WEBPACK FOOTER //
// ./src/page/gjyxb/router.js